import React from 'react'

import Stack from '@mui/material/Stack'
import { Text } from '@mxenabled/mxui'
import { CurrencyInput, useGlobalCopyStore } from '../../../common'
import { buildDynamicCopy } from '../../../core/utils/Localization'

interface BudgetAmountProps {
  amount: string
  categoryName: string
  onAmountChanged: (amount: string) => void
}

export const BudgetAmount: React.FC<BudgetAmountProps> = ({
  amount,
  categoryName,
  onAmountChanged,
}) => {
  const { budgets: copy } = useGlobalCopyStore()

  return (
    <Stack gap={16}>
      <Stack>
        <Text>{buildDynamicCopy(copy.add_description_bottom, categoryName) as string}</Text>
      </Stack>
      <CurrencyInput
        amount={amount}
        autoFocus={true}
        label={copy.add_label}
        minAmount={0}
        setAmount={onAmountChanged}
        sx={{ '.MuiTypography-body1': { p: 0 } }}
      />
    </Stack>
  )
}
